import { get } from 'lodash';

export const getPromotion = (state, { id }) => get(state, `subscriptions.promotions.data.${id}`);
export const arePromotionLoading = state => get(state, 'subscriptions.promotions.loading');
